export default {
    //Telegram
    TelegramFlows: [],
    TelegramAccounts: [],
    ActiveTelegramAccount: {},
    TelegramBroadcasts: [],
    TelegramSequences: [],
}